<template>
    <span class="users-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
            <rect width="256" height="256" fill="none" />
            <circle
                cx="88"
                cy="108"
                r="52"
                fill="none"
                :stroke="fill"
                stroke-miterlimit="10"
                stroke-width="16"
            />
            <path
                fill="none"
                :stroke="fill"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="16"
                d="M155.41251 57.937A52.00595 52.00595 0 1 1 169.52209 160M15.99613 197.39669a88.01736 88.01736 0 0 1 144.00452-.00549M169.52209 160a87.89491 87.89491 0 0 1 72.00032 37.3912"
            />
        </svg>
    </span>
</template>

<script>
export default {
    name: 'IconUsers',
    props: {
        fill: {
            type: String,
            default: '#fff',
        },
    },
};
</script>
